<div class="container-indication">
    <p class="indication">
        Es ideal que completes todos los bloques para un pronóstico más preciso. Puedes continuar después de completar
        este bloque.
    </p>
    <button class="btn-indication" (click)="resetComponent()">Contraer todo</button>
</div>
<div *ngFor="let dimension of test.dimensions; let i = index" class="test-container" [style.borderColor]="expandedIndex === i ? '#77a5d8' : '#000000cc'">
    <!-- Modo contraído -->
    <div class="test-header" (click)="toggleExpand(i)">
        <h3 class="test-title" [style.color]="expandedIndex === i ? '#77a5d8' : '#2d5476'">{{ dimension.name }}</h3>
        
        <!-- Mostrar solo "Completado" con check mark si la dimensión está completada -->
        <div *ngIf="dimension.completed" class="completion-status">
            Completado <span class="check-icon">✓</span>
        </div>
        
        <!-- Mostrar los círculos de progreso solo si no está completada -->
        <div *ngIf="!dimension.completed" class="stages">
            <ng-container *ngFor="let stage of dimension.questions; let stageIndex = index">
                <div class="stage-circle"
                    [ngClass]="{'active':( i === expandedIndex && stageIndex <= currentQuestionIndex)}" 
                    >
                    {{ stageIndex + 1 }}
                </div>
                <!-- Línea entre círculos, solo se muestra si no es el último elemento -->
                <div *ngIf="stageIndex < dimension.questions.length - 1" class="step-line"></div>
            </ng-container>
        </div>
    </div>

    <!-- Modo expandido -->
    <div [@expandCollapse]="expandedIndex === i ? 'expanded' : 'collapsed'" class="test-expanded">
        <div class="stage-container" *ngIf="dimension.questions?.[currentQuestionIndex] && !(dimension.completed)">
            <div class="statement-section">
                <h3 [style.color]="expandedIndex === i ? '#77a5d8' : '#2d5476'">{{currentQuestionIndex + 1}}- {{ dimension.questions[currentQuestionIndex].name }}</h3>
                <ul class="bullet-points">
                    <li *ngFor="let point of formatQuestionTitle(dimension.questions[currentQuestionIndex].title)">
                        {{ point }}
                    </li>
                </ul>
            </div>
            <div class="score-section">
                <p class="puntua">Puntúa aquí:</p>
                <div class="score" [ngClass]="{'active-range': activeRangeToday}">
                    <div class="score-header">
                        <p>Hoy, ¿Qué tan satisfecho te sientes con estos aspectos?</p>
                        <span *ngIf="showTodayCheckIcon" class="check-icon-green">✓</span>
                    </div>
                    <div class="range-container">
                        <div class="range-values">
                            <span>0</span>
                            <span>10</span>
                        </div>
                        <app-range [value]="currentValueNow" [index]="currentQuestionIndex"
                            (onChange)="changeRangeToday($event, dimension.questions[currentQuestionIndex])"
                            (onFocus)="setActiveRangeToday()"></app-range>
                    </div>
                </div>
                <div class="score" [ngClass]="{'active-range': activeRangeFuture}">
                    <div class="score-header">
                        <p>¿Cómo quieres estar en el largo plazo?</p>
                        <span *ngIf="showFutureCheckIcon" class="check-icon-green">✓</span>
                    </div>
                    <div class="range-container">
                        <div class="range-values">
                            <span>0</span>
                            <span>10</span>
                        </div>
                        <app-range [value]="currentValueFuture" [index]="currentQuestionIndex"
                            (onChange)="changeRangeFuture($event, dimension.questions[currentQuestionIndex])"
                            (onFocus)="setActiveRangeFuture()"></app-range>
                    </div>
                </div>
                <div class="button-stage">
                    <button (click)="nextQuestion(dimension)" class="next-button">{{ currentQuestionIndex === dimension.questions.length
                        - 1 ? 'Completar y ver promedio' : 'Siguiente'}}</button>
                </div>
            </div>
        </div>
        <div class="results-section" *ngIf="dimension.completed">
            <div class="results-left">
                <h3 class="results-title">¡Guardado correctamente!</h3>
                <p class="results-text">Tus resultados de la dimensión "{{dimension.name}}" se guardaron correctamente, estos son los
                    promedios de tus respuestas. Estos puntajes servirán para tu cita con tu mentor.</p>
            </div>
            <div class="results-right">
                <p class="results-label">Resultados:</p>
                <div class="results-cards">
                    <div class="results-card">
                        <h3 class="results-card-title">Hoy</h3>
                        <div class="results-card-value">{{getAverage(dimension, 'now')}}</div>
                        <div class="results-card-subtitle">Promedio</div>
                    </div>
                    <div class="results-card">
                        <h3 class="results-card-title">7 años</h3>
                        <div class="results-card-value">{{getAverage(dimension, 'future')}}</div>
                        <div class="results-card-subtitle">Promedio</div>
                        <div class="percentage-badge" *ngIf="getPercentageIncrease(dimension) > 0">
                            {{getPercentageIncrease(dimension)}}%↑
                        </div>
                    </div>
                </div>
                <div class="next-dimension-button">
                    <button (click)="nextDimension(i)" class="next-button-dark">Siguiente dimensión</button>
                    <button class="btn-ver-resultados" (click)="toggleResultados(dimension)">{{ mostrandoResultados ? 'Ocultar resultados' : 'Ver resultados de dimensión' }}</button>
                </div>
                
                <!-- Sección de resultados detallados -->
                <div *ngIf="mostrandoResultados && dimensionSeleccionada === dimension" class="detailed-results">
                    <h3 class="detailed-results-title">Resultados detallados por pregunta</h3>
                    <div class="table-container">
                        <table class="results-table">
                            <thead>
                                <tr>
                                    <th>Pregunta</th>
                                    <th>Hoy</th>
                                    <th>7 años</th>
                                    <th>Diferencia</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let question of dimension.questions; let qIndex = index">
                                    <td>{{ qIndex + 1 }}. {{ question.name }}</td>
                                    <td>{{ question.answer.valueNow }}</td>
                                    <td>{{ question.answer.valueFuture }}</td>
                                    <td [ngClass]="{'positive-change': (question.answer.valueFuture - question.answer.valueNow) > 0}">
                                        {{ question.answer.valueFuture - question.answer.valueNow > 0 ? '+' : '' }}{{ question.answer.valueFuture - question.answer.valueNow }}
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td><strong>Promedio</strong></td>
                                    <td><strong>{{ getAverage(dimension, 'now') }}</strong></td>
                                    <td><strong>{{ getAverage(dimension, 'future') }}</strong></td>
                                    <td [ngClass]="{'positive-change': (getAverageRaw(dimension, 'future') - getAverageRaw(dimension, 'now')) > 0}">
                                        <strong>{{ (getAverageRaw(dimension, 'future') - getAverageRaw(dimension, 'now')) > 0 ? '+' : '' }}{{ (getAverageRaw(dimension, 'future') - getAverageRaw(dimension, 'now')).toFixed(1) }}</strong>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>